import type { MenuItem } from '@/utils/menu';
import { defineStore } from 'pinia';

interface AppState {
  routesLoaded: boolean;
  menus: MenuItem[];
  navHeight: number;
  dialogMaxHeight?: number;
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    routesLoaded: false,
    menus: [],
    navHeight: 60,
    dialogMaxHeight: window.innerHeight * 0.8,
  }),
  actions: {
    setRoutesLoaded(val: boolean) {
      this.routesLoaded = val;
    },
    setMenus(menus: MenuItem[]) {
      this.menus = menus;
    },
  },
});
